import { render, staticRenderFns } from "./SectionTestimonials.vue?vue&type=template&id=bad7e90c&scoped=true"
import script from "./SectionTestimonials.vue?vue&type=script&lang=js"
export * from "./SectionTestimonials.vue?vue&type=script&lang=js"
import style0 from "./SectionTestimonials.vue?vue&type=style&index=0&id=bad7e90c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bad7e90c",
  null
  
)

export default component.exports